export default function VideoMode({ videoRef, onEndSession }) {
  const handleCameraFlip = () => {
    // TODO: Implement camera flip functionality
    console.log('Camera flip clicked')
  }

  const handleMicToggle = () => {
    // TODO: Implement microphone toggle
    console.log('Microphone toggle clicked')
  }

  const handleFlashToggle = () => {
    // TODO: Implement flash toggle
    console.log('Flash toggle clicked')
  }
  return (
    <div className="fixed inset-0 bg-black z-50">
      {/* Video Feed */}
      <video 
        ref={videoRef}
        autoPlay 
        playsInline 
        muted
        className="w-full h-full object-cover"
      />
      
      {/* Controls at bottom - Exact ChatGPT style */}
      <div className="absolute bottom-0 left-0 right-0 p-6 bg-gradient-to-t from-black/80 to-transparent">
        <div className="flex items-center justify-center gap-6">
          {/* Camera Flip - Two curved arrows */}
          <button 
            onClick={handleCameraFlip}
            className="w-12 h-12 bg-gray-800 bg-opacity-80 rounded-full flex items-center justify-center text-white hover:bg-gray-700 transition-colors"
          >
            <svg width="24" height="24" viewBox="0 0 24 24" fill="currentColor">
              <path d="M12 6v3l4-4-4-4v3c-4.42 0-8 3.58-8 8 0 1.57.46 3.03 1.24 4.26L6.7 14.8c-.45-.83-.7-1.79-.7-2.8 0-3.31 2.69-6 6-6z"/>
              <path d="M18.76 7.74L17.3 9.2c.44.84.7 1.79.7 2.8 0 3.31-2.69 6-6 6v-3l-4 4 4 4v-3c4.42 0 8-3.58 8-8 0-1.57-.46-3.03-1.24-4.26z"/>
            </svg>
          </button>
          
          {/* Microphone */}
          <button 
            onClick={handleMicToggle}
            className="w-12 h-12 bg-gray-800 bg-opacity-80 rounded-full flex items-center justify-center text-white hover:bg-gray-700 transition-colors"
          >
            <svg width="24" height="24" viewBox="0 0 24 24" fill="currentColor">
              <path d="M12 14c1.66 0 2.99-1.34 2.99-3L15 5c0-1.66-1.34-3-3-3S9 3.34 9 5v6c0 1.66 1.34 3 3 3zm5.3-3c0 3-2.54 5.1-5.3 5.1S6.7 14 6.7 11H5c0 3.41 2.72 6.23 6 6.72V21h2v-3.28c3.28-.48 6-3.3 6-6.72h-1.7z"/>
            </svg>
          </button>
          
          {/* Flash Off - Lightning bolt with diagonal strike */}
          <button 
            onClick={handleFlashToggle}
            className="w-12 h-12 bg-gray-800 bg-opacity-80 rounded-full flex items-center justify-center text-white relative hover:bg-gray-700 transition-colors"
          >
            <svg width="24" height="24" viewBox="0 0 24 24" fill="currentColor">
              <path d="M13 2L4.09 12.97c-.14.21-.02.53.2.53H9l-2 8 8.91-10.97c.14-.21.02-.53-.2-.53H11l2-8z"/>
            </svg>
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" className="absolute">
              <line x1="4" y1="4" x2="20" y2="20" stroke="currentColor" strokeWidth="3" strokeLinecap="round"/>
            </svg>
          </button>
          
          {/* End Call - X */}
          <button 
            onClick={onEndSession}
            className="w-12 h-12 bg-gray-800 bg-opacity-80 rounded-full flex items-center justify-center text-white"
          >
            <svg width="24" height="24" viewBox="0 0 24 24" fill="currentColor">
              <path d="M19 6.41L17.59 5 12 10.59 6.41 5 5 6.41 10.59 12 5 17.59 6.41 19 12 13.41 17.59 19 19 17.59 13.41 12z"/>
            </svg>
          </button>
        </div>
      </div>
    </div>
  )
}
